export default {
  logo: "",
  favicon: "",
  primaryColor: ""
};
